const RECENT_CHAT_SEARCHES_KEY_PREFIX = "agentic_ai_recent_chat_searches";

export const RECENT_CHAT_SEARCHES_LIMIT = 6;

/** A chat search starts, and is saved, only from this many characters. */
export const CHAT_SEARCH_MIN_CHARS = 2;

/** One list per user, so a list stays with its owner across logout and login. */
export const getRecentChatSearchesKey = (email: string) =>
  `${RECENT_CHAT_SEARCHES_KEY_PREFIX}:${email}`;

export const addRecentChatSearch = (list: string[], term: string): string[] => {
  const trimmedTerm = term.trim();
  if (!trimmedTerm) return list;

  const others = list.filter(
    (saved) => saved.toLowerCase() !== trimmedTerm.toLowerCase()
  );
  return [trimmedTerm, ...others].slice(0, RECENT_CHAT_SEARCHES_LIMIT);
};

/**
 * The stored JSON is not checked on read, so drop anything that is not a
 * string of the minimum length (this also hides 1-character terms saved before
 * the minimum existed).
 */
export const sanitizeRecentChatSearches = (value: unknown): string[] =>
  Array.isArray(value)
    ? value.filter(
        (term): term is string =>
          typeof term === "string" &&
          term.trim().length >= CHAT_SEARCH_MIN_CHARS
      )
    : [];

/** The user is not known until the profile loads, so a missing email gives an empty list. */
export const readRecentChatSearches = (email?: string): string[] => {
  if (!email) return [];

  try {
    const stored = localStorage.getItem(getRecentChatSearchesKey(email));
    return sanitizeRecentChatSearches(stored ? JSON.parse(stored) : []);
  } catch (error) {
    console.error(error);
    return [];
  }
};

/** Must not throw: blocked storage should not break the search page. */
export const writeRecentChatSearches = (email: string, terms: string[]) => {
  try {
    localStorage.setItem(
      getRecentChatSearchesKey(email),
      JSON.stringify(terms)
    );
  } catch (error) {
    console.error(error);
  }
};
